// src/api/endpoints.js

const API_BASE_URL = "https://mlm-backend-9fnq.onrender.com/api/user"; // Replace with your base URL

export const API_ENDPOINTS = {
  REGISTER: `${API_BASE_URL}/register-user`,
  LOGIN: `${API_BASE_URL}/login-user`,

};
